import { Fragment, type ReactNode } from "react";

import { useCheckIfModuleDisabled } from "@/hooks/useCheckIfModuleDisabled";
import { useLayoutContext } from "@/layouts/LayoutContext";

import { useGetOnlineUsers } from "../hooks/useGetOnlineUsers";
import { usePrivateUserChannel } from "../hooks/usePrivateUserChannel";
import {
  type InitialState,
  MessengerContext,
  useCreateMessengerStore,
} from "../store";
import MessengerCompact from "./MessengerCompact";

const initialState = {} as InitialState;

function MessengerChannels() {
  useGetOnlineUsers();
  usePrivateUserChannel();
  return null;
}

export default function MessengerWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const active = useCheckIfModuleDisabled("messenger");
  const { hideWidgets } = useLayoutContext();

  const store = useCreateMessengerStore({
    ...initialState,
  });

  return (
    <Fragment>
      <MessengerContext.Provider value={store}>
        <MessengerChannels />
        {active && !hideWidgets && <MessengerCompact />}
        {children}
      </MessengerContext.Provider>
    </Fragment>
  );
}
